
import Hierarchy from "../../../assets/filled/Hierarchy.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HierarchyIcon({ className, dataTestid = "HierarchyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Hierarchy data-testid={dataTestid} className={classes} {...rest} />
  );
}
